import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import ReportLayoutSlide from './Layouts/ReportLayoutSlide.vue'
import { useRoute, useRouter } from 'vue-router'
import { useReportStore } from '../model/store'
import { AvailableYear, ReportTarget } from '../model/types/report'
import { getReportBreadcrumbs } from '../model/helpers'
import { setBreadcrumbs } from '@/features/Breadcrumbs'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySlideMode',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const reportStore = useReportStore()

const country = computed<ReportTarget>(() => ({
	population: reportStore.state.commonInfo?.population,
	density: reportStore.state.commonInfo?.populationDensity,
	name: 'Россия',
	type: 'country'
}))

const toDistrict = (districtId: number) => {
	router.push(`/district/${districtId}/${route.params.year}`)
}

setBreadcrumbs(getReportBreadcrumbs(
	country.value.type,
	route.params.year as AvailableYear
))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ReportLayoutSlide, {
    target: _unref(country),
    onTo: toDistrict
  }, null, 8, ["target"]))
}
}

})